/**
 * Created by lenovo on 2017/3/13.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import userService from 'SERVICES/ella/userService'
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import Tip from 'CONFIG/component/tip'
import BoxHeader from 'CONFIG/component/boxHeader'
import {mapToJSON,checkInput} from 'CONFIG/function'
import {alertTip,resultTip} from 'UTIL/common'
import {Link,hashHistory} from 'react-router'
export default class AreaPermission extends Component {
    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.state = {
            userId : this.props.params.id,
            list : {},
            zoomsList : [],
            hadAuth : [],
        };
    }

    componentDidMount() {
        $('#add').click(function(){
            //获取选中的选项，删除并追加给对方
            $('#select1 option:selected').appendTo('#select2');
        });

        //移到左边
        $('#remove').click(function(){
            $('#select2 option:selected').appendTo('#select1');
        });

        //全部移到右边
        $('#add_all').click(function(){
            //获取全部的选项,删除并追加给对方
            $('#select1 option').appendTo('#select2');
        });

        //全部移到左边
        $('#remove_all').click(function(){
            $('#select2 option').appendTo('#select1');
        });

        //双击选项
        $('#select1').dblclick(function(){ //绑定双击事件
            //获取全部的选项,删除并追加给对方
            $("option:selected",this).appendTo('#select2'); //追加给对方
        });

        //双击选项
        $('#select2').dblclick(function(){
            $("option:selected",this).appendTo('#select1');
        });
        this.getData();
    }
    getData(){
        var search = $.trim($("#search").val());
        if(search ==""){
            search ="''";
        }
        userService.zoomAuth(this.state.userId,search).then(body =>{
            console.log(body.data)
            this.setState({
                list : body.data.userbase,
                zoomsList : body.data.zooms,
                hadAuth : body.data.hadAuth,
            })
        })
    }
    btnSubmit(){
        var obj = document.getElementById('select2');
        var options = obj.options;
        var parks = [];
        for(let i=0,len=options.length;i<len;i++){
            let opt = options[i];
           parks.push({"pid":opt.value,"pname":opt.text})
        }
       if(parks.length == 0){
            alertTip("请选择区域")
       }else{
           const arr = {
               parks:parks,
               userId : this.state.userId,
           }
           const data = JSON.stringify(arr);
           userService.zoomSave({data}).then(msg =>{
               if (msg.code == 8001) {
                   $("#success_msg").text(msg.msg);
                   $("#success_tip").removeClass("hidden");
                   setTimeout(function () {
                       hashHistory.push("/ella/user/user/userList")
                       $("#success_tip").addClass("hidden");
                   }, 4000);
               } else {
                   $("#error_msg").text(msg.msg);
                   $("#error_tip").removeClass("hidden");
                   setTimeout(function () {
                       $("#error_tip").addClass("hidden");
                   }, 4000);
               }
           })
       }
    }
    render() {
        const zooms = this.state.zoomsList.map((str,index)=> {
            return <option value={str.regionId} key={index}>{str.regionName}</option>
        });
        const hadAuth  = this.state.hadAuth.map((str,index)=>{
            return <option value={str.pid} key={index}>{str.pname}</option>
        });
        const btnStyle = {padding:"5px",width:"30px",margin:"5px"};
        const selectStyle = {float:"left",height:"300px",overflow:"auto",width:"200px"};
        return (
            <div >
                <ContentHeader nameLg="用户列表" nameSm="区域权限授权"/>
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <BoxHeader title="区域权限授权"  />
                        <div className="box-body" style={{marginLeft:"15px"}}>
                            <Tip ids={""}/>
                            <div className="row invoice-info">
                                <div className="col-sm-4 invoice-col">
                                    <label>用户名:  {  this.state.list.realName}</label><br/>
                                    <label>联系方式: {  this.state.list.telephone}</label><br/>
                                    <label>地址: {  this.state.list.address}</label><br/>
                                </div>
                            </div>
                            <br/>
                            <form>
                                <div >
                                    <input type="text"  id="search" placeholder="搜索区域"
                                           style={{"width":"200px","marginBottom":"5px"}} onChange={this.getData}/>
                                    <br/>
                                    <select id="select1" multiple="multiple" style={selectStyle}>
                                        {zooms}
                                    </select>
                                </div>
                                <div style={{"float":"left",padding:"30px 10px"}}>
                                    <button id="add" style={btnStyle}>{">"}</button><br />
                                    <button id="add_all" style={btnStyle}>{">>"}</button><br />
                                    <button id="remove" style={btnStyle}>{"<"}</button><br />
                                    <button id="remove_all" style={btnStyle}>{"<<"}</button>
                                </div>
                                <div >
                                    <select  id="select2" multiple="multiple" style={selectStyle}>
                                        {hadAuth}
                                    </select>
                                </div>

                            </form>

                        </div>
                        <div className="box-footer">
                            <div className="row form-group">
                                <div className="col-xs-1"></div>
                                <div className="col-xs-1 text-center">
                                    <button className="btn btn-success" onClick={this.btnSubmit.bind(this)}>提交</button>
                                </div>
                                <div className="col-xs-1 text-center">
                                    <Link to="/ella/user/user/userList"
                                          className="btn btn-danger btn-md">
                                        返回
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/areaPermission.js